import { createAction } from '@reduxjs/toolkit';
import { Asset, LoadSharingAssetsReturn, SharingLink } from '../../api';
import { ShareContext } from './model';
import { Loading, LoadingMode } from '../finder/model';

export const loadDataRequested = createAction<
  { mode: LoadingMode },
  'al/sharing/loadDataRequested'
>('al/sharing/loadDataRequested');

export const setLoading = createAction<{ loading: Loading }, 'al/sharing/setLoading'>(
  'al/sharing/setLoading',
);

export const assetsChanged = createAction<
  { data: LoadSharingAssetsReturn; hasNextPage: boolean; scrollHash: string },
  'al/sharing/assetsChanged'
>('al/sharing/assetsChanged');

export const thumbnailUpdated = createAction<{ assetId: Asset['id']; url: Asset['thumbnail_url'] }>(
  'al/sharing/thumbnailUpdated',
);

export const shareAssetsClicked = createAction<
  { assetIds?: Asset['id'][]; selectAll?: boolean },
  'al/sharing/shareAssetsClicked'
>('al/sharing/shareAssetsClicked');

export const sharePackClicked = createAction<void, 'al/sharing/sharePackClicked'>(
  'al/sharing/sharePackClicked',
);

export const shareSharingClicked = createAction<
  { sharingId: SharingLink['id'] },
  'al/sharing/shareSharingClicked'
>('al/sharing/shareSharingClicked');

export const setShareInProgress = createAction<
  | { context: ShareContext.pack; inProgress: boolean }
  | { context: ShareContext.asset; inProgress: boolean; assetIds: Asset['id'][] }
  | { context: ShareContext.allAssets; inProgress: boolean }
  | { context: ShareContext.sharing; inProgress: boolean; sharingId: SharingLink['id'] },
  'al/sharing/setShareInProgress'
>('al/sharing/setShareInProgress');

export const editClicked = createAction('al/sharing/editClicked');

export const setIsReplacingPack = createAction<{ isReplacingPack: boolean }>(
  'al/sharing/setIsReplacingPack',
);
